import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tags_picker',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'tag',
    viewPath: props.viewPath,
    path: 'id',
  })

  return function onClick() {
    submit({
      type: 'delete_tag',
      id,
    })
  }
}
